// material-ui
import { Box, Typography } from "@mui/material"
import { useSelector, useDispatch } from "react-redux"
import { useState, useEffect } from "react"
// project import
import NavGroup from "./NavGroup"
import NAVIGATION from "menu-items"
import { useLocation } from "react-router"
import { activeItem, inActive } from "store/reducers/menu"
// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  const [navigationItems, setNavigationItems] = useState(NAVIGATION)
  const { isLogin, user } = useSelector((state) => state.user)
  const navigation = useLocation()
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  useEffect(() => {
    if (isLogin) {
      let items = navigationItems?.items?.filter(
        (item) => item.id !== "authentication"
      )
      //filtering  admin routes
      if (user.userType == 3) {
        //removing dashboard paths
        items = items?.filter((item) => item.id !== "dashboard")
      } else {
        items = items?.filter((item) => item.id !== "admin")
      }

      setNavigationItems({ items: items })
    } else {
      setNavigationItems(NAVIGATION)
    }
  }, [isLogin])
  useEffect(() => {
    let flag = true
    const groupItems = navigationItems.items.filter((item) => {
      return item.type == "group"
    })
    groupItems.forEach((item) => {
      item.children.forEach((item) => {
        if (pathname.includes(item.url)) {
          // console.log("active ")

          flag = false
          dispatch(activeItem({ openItem: [item.id] }))
        }
      })
    })
    if (flag) {
      dispatch(inActive())
    }

    // if (flag) dispatch(inActive())

    // eslint-disable-next-line
  }, [pathname, navigationItems])
  const navGroups = navigationItems?.items?.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        )
    }
  })

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>
}

export default Navigation
